module.exports = __webpack_public_path__ + "img/節能標章.334a3b8b.jpg";